<template>
    <div>
        <!-- Modal Identificar NF para o Crédito -->
        <div class="modal fade" id="creditoIdentNFModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Identificar Nota Fiscal</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="credito">
                            <table class="table">
                                <tr>
                                    <th>Data</th>
                                    <th class="text-right">Crédito</th>
                                    <th class="text-right">Retenções</th>
                                    <th class="text-right">Total</th>
                                </tr>
                                <tr>
                                    <td>{{ $util.getFormatDate(credito.dt_recebimento) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(credito.dc_valor) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(credito.dc_retencoes) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(credito.dc_valor + credito.dc_retencoes) }}</td>
                                </tr>
                            </table>
                        </template>

                        <hr>

                        <template v-if="credito && credito.nota">
                            <div class="alert alert-info">
                                <div>{{ credito.nota.search }}</div>
                                <button type="button" class="btn btn-outline-danger mt-3" @click="credito.nota = null">
                                    Remover Vínculo
                                </button>
                            </div>
                        </template>

                        <template v-else>
                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-6">
                                    <az-periodo v-model="filtro" :sync="true" @sync="buscar_notas()" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        icon="fa fa-search fa-fw"
                                        v-model="filtro.pesquisa" 
                                        placeholder="Pesquisar..." />
                                </div>
                            </div>

                            <div class="list-group mb-3">
                                <button type="button" 
                                    class="list-group-item list-group-item-action d-flex justify-content-between"  
                                    :class="nf.expanded ? 'active' : ''"
                                    v-for="(nf, inx) in lista_notas" :key="inx" @click="selecionar_nota(nf)">

                                    <div>
                                        {{ nf.search }}

                                        <span class="badge badge-light ml-3" v-if="nf.unidade_operacao && nf.unidade_operacao.st_sigla">
                                            {{ nf.unidade_operacao.st_sigla }}
                                        </span>
                                    </div>

                                    <div>
                                        <div class="text-right">
                                            Saldo: {{ $util.formatMoeda(nf.saldo_credito) }}
                                        </div>
                                        <div class="small text-muted text-right" v-if="nf.creditos && nf.creditos.length">
                                            Faturas: {{ nf.creditos.map(item => '#' + item.id_fatura).join(', ') }}
                                        </div>
                                    </div>
                                </button>
                            </div>

                            <div class="form-row" v-if="false">
                                <div class="col col-12 col-md-6">
                                    <pre class="alert alert-warning">{{ credito }}</pre>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <pre class="alert alert-info">{{ notas }}</pre>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()" v-if="!(credito && credito.nota)">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            credito: null, 
            notas: [], 
            filtro: { 
                periodo: "m",
                pesquisa: "", 
            }
        }
    },

    components: { 
        AzPeriodo, 
        AzInput, 
        AzSubmit, 
    },

    computed: { 
        lista_notas: function () { 
            if ( !this.notas ) { 
                return [];
            }

            let reg = this.$util.getregex(this.filtro.pesquisa);

            return this.notas.filter(nf => !this.filtro.pesquisa || reg.test(nf.search));
        },
    },
    
    methods: { 
        atualizar () { 
            let nota = this.lista_notas.find(nf => nf.expanded);

            this.$util.atualizar(this, { 
                service: 'fatura_creditos',
                func: 'ident_nf',
                dados: { 
                    id_fatura_credito: this.credito.id_fatura_credito,
                    id_nota_fiscal_servico: nota ? nota.id_nota_fiscal_servico : null, 
                },
                callback: () => { 
                    this.$emit('refresh');
                    $('#creditoIdentNFModal').modal('hide');
                }
            });
        },

        selecionar_nota (nf) { 
            if ( nf.expanded ) { 
                nf.expanded = false;
                return;
            }

            this.notas.forEach(n => n.expanded = false);

            if ( nf.saldo_credito < this.credito.dc_valor ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Saldo insuficiente: " + this.$util.formatMoeda(nf.saldo_credito),
                    life: 3000
                });
                return;
            }

            nf.expanded = true;
        },

        buscar_notas () { 
            this.$util.load(this, { 
                service: 'nota_fiscal_servico',
                func: 'index',
                parms: { 
                    id_fatura_credito: this.credito.id_fatura_credito,
                    ...this.filtro,
                    ident_nf: true, 
                },
                loadTo: res => { 
                    this.notas = res;
                }
            });
        },

        abrir (credito) { 
            $('.modal').modal('hide');

            this.credito = _.cloneDeep(credito);

            this.buscar_notas();

            $('#creditoIdentNFModal').modal('show');
        }
    }
}
</script>
